// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.5.0",
  date: "2026-08-14T06:08:33.249Z",
  gitInfo: {
    dirty: false,
    raw: "ea37ea9fb",
    hash: "ea37ea9fb",
    distance: null,
    tag: null,
    semver: null,
    suffix: "ea37ea9fb",
    semverString: null
  }
};
/* tslint:enable */
